<template>
  <div>
    <div class="content d-flex flex-column mt-2" v-if="fields">      
      <div class="row">
        <div class="col">
          <div class="d-flex justify-end mb-1" v-if="canEdit">
             <v-btn small text color="primary" @click="generateMetodologia" :loading="loading">
               Preencher com dados do Cronograma
             </v-btn>
          </div>
          <input-v
            v-model="projeto.metodologia_li"
            :valid.sync="fieldsComputed.metodologia_li.valid"
            :label="fieldsComputed.metodologia_li"            
            :editable="canEdit"
            :opts="opts"
          >
          </input-v>
        </div>        
      </div>      
      <div class="row">
        <div class="col">
          <input-v
            v-model="projeto.resultado_li"
            :valid.sync="fieldsComputed.resultado_li.valid"
            :label="fieldsComputed.resultado_li"            
            :editable="canEdit"
            :opts="opts"
          >
          </input-v>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <input-v
            v-model="projeto.informacoes_complementares_li"
            :valid.sync="fieldsComputed.informacoes_complementares_li.valid"
            :label="fieldsComputed.informacoes_complementares_li"            
            :editable="canEdit"
            :opts="opts"
          >
          </input-v>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { cloneDeep } from "lodash";
import fields from '../LIEnquadrados.fields';
import { isStrictProject } from "@/helpers/projectValidators";
import moment from "moment";
import { mapGetters } from "vuex";

export default {
  props: {
    projeto: {
      type: Object,
      required: true
    },
    canEdit: {
      type: Boolean,
      required: true,
      default: false
    },
    canEditStatus: {
      type: Boolean,
      required: true,
      default: false
    },
    isClient: {
      type: Boolean,
      required: true,
      default: false
    },
    cliente: {
      type: Object,
      required: true
    },
    hasAccessPlurianual: {
      type: Boolean,
      required: true,
      default: false
    },
    opts: {
      type: Object,
      required: true,
      default: function() {
        return {};
      }
    }
  },
  components: {
    'input-v': () => import('@/components/input-v.vue'),
  },
  data() { 
    return {
      fields,
      loading: false,
    }
  },
  computed: {
    ...mapGetters(["clientId"]),
    fieldsComputed: function() {
      const fields = cloneDeep(this.fields.resultados);
      const isStrict = isStrictProject(this.projeto);

      return fields.reduce(
        (acc, field) => {
          if (!isStrict) {
             field.rules = (field.rules || []).filter(r => r.rule !== 'required');
          }
          return { ...acc, [field.key]: field }
        },
        {}
      );
    },
  },
  methods: {
    async generateMetodologia(isAuto = false) {
      if (!isAuto && this.projeto.metodologia_li) {
        this.showConfirm(
           "Sobrescrever dados",
           "O campo metodologia já possui dados. Deseja sobrescrevê-lo com os dados do cronograma?",
           () => this.runGenerateMetodologia(isAuto)
        );
        return;
      }
      
      await this.runGenerateMetodologia(isAuto);
    },
    async runGenerateMetodologia(isAuto) {
      this.loading = true;
      try {
        const resource = this.apiResource(`/v1/projetos/${this.clientId}/cronograma`);
        // Lei de Informática ID = 2
        const response = await resource.get({ id: this.projeto.id, query: `trabalho=2` }); 
        
        let text = "";
        let activityCount = 1;

        if (Array.isArray(response)) {
             response.forEach((me, index) => {
                 text += `<b>ME ${index + 1}:</b> ${me.me}\n </br>`;
                 me.atividades.forEach((atv) => {
                     const start = atv.data_inicio ? moment(atv.data_inicio).format('DD/MM/YYYY') : '-';
                     const end = atv.data_fim ? moment(atv.data_fim).format('DD/MM/YYYY') : '-';
                     
                     text += `<b>Atividade ${activityCount}:</b> ${atv.nome}\n </br>`;
                     text += `<b>Descrição:</b> ${atv.descricao || '-'}\n`;
                     text += `<b>Resultado da atividade:</b> ${atv.resultado || '-'}\n`;
                     text += `<b>Período:</b> ${start} a ${end}\n </br>`;
                     text += `<b>Participantes:</b> ${(atv.participantes && atv.participantes.length > 0) ? atv.participantes.join(', ') : '-'}\n\n </br><hr>`;
                     
                     activityCount++;
                 });
                 text += "\n </br>";
             });
        }
        
        this.$set(this.projeto, 'metodologia_li', text);
        
        if (!isAuto) {
            this.$notify({
                group: "geral",
                title: "Sucesso",
                text: "Metodologia gerada com sucesso!",
                type: "success"
            });
        }
        
      } catch (e) {
        console.error(e);
        this.$notify({
            group: "geral",
            title: "Erro",
            text: "Erro ao gerar metodologia",
            type: "error"
        });
      } finally {
        this.loading = false;
      }
    }
  },
  watch: {},
  created() {},
  mounted() {
      if (!this.projeto.metodologia_li) {
          this.generateMetodologia(true);
      }
  },
  beforeDestroy() {}
}
</script>

<style scoped>
</style>